<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">NARUČENE KOLIČINE ZA RAZDOBLJE</h2>

  <!-- bio je samo jedan odabir datuma pa je dodano da se odabire datum od i datum do -->
  <!--
<div class="content-block">
  <div class="dx-field">
    <div class="dx-field-value w-datebox dateBox">
      <dx-date-box
        applyValueMode="useButtons"
        pickerType="calendar"
        displayFormat='dd.MM.yyyy.'
        placeholder="Odaberite datum"
        (onValueChanged)="onValueChanged($event)"
      >
        <!-- [(value)]="currentValue" - ->
      </dx-date-box>
    </div>
  </div>
</div>
-->

  <div class="content-block">
    <div class="dx-field">
      <!-- <div class="dx-field-value w-datebox dateBox"> -->
      <div class="dateBox marginRight">
        <dx-date-box
          applyValueMode="useButtons"
          [(value)]="datumOd"
          [(max)]="datumDo"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          placeholder="Datum od"
          (onValueChanged)="onValueChangedDatumOd($event)"
        >
          <!-- [(value)]="currentValue" -->
        </dx-date-box>
      </div>
      <div class="dateBox">
        <dx-date-box
          applyValueMode="useButtons"
          [(value)]="datumDo"
          [(min)]="datumOd"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          placeholder="Datum do"
          (onValueChanged)="onValueChangedDatumDo($event)"
        >
        </dx-date-box>
      </div>
    </div>
  </div>

  <div *ngIf="datumOdabran" class="customTable naruceneKolicine m-40">
    <div id="data-grid-demo">
      <dx-data-grid
        #dataGrid
        id="gridContainer"
        [dataSource]="proizvodi"
        [wordWrapEnabled]="true"
        noDataText="{{ poruka }}"
        keyExpr="sifra"
        [showColumnLines]="true"
        [showBorders]="false"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onCellPrepared)="onCellPrepared($event)"
        (onRowClick)="onRowClick($event)"
        (onCellClick)="onCellClick($event)"
        (onRowExpanding)="onRowExpanding($event)"
        (onRowPrepared)="onRowPrepared($event)"
        [masterDetail]="{ enabled: true, template: 'detail' }"
      >
        <div *dxTemplate="let data of 'naslovTablice'">
          <div class="naslov">
            <h2 class="mb-0">
              Izvještaj neobrađenih količina za razdoblje od
              {{ razdobljeOd }} do {{ razdobljeDo }}
            </h2>
            <!-- <h2 class="mb-0">
            Izvještaj neobrađenih količina za razdoblje do {{ razdobljeDo }}
          </h2> -->
            <p class="mt-0">
              Praćenje izvještaja u odabranom vremenskom razdoblju za naručene
              količine
            </p>
          </div>
        </div>

        <dxo-search-panel
          [visible]="true"
          [width]="240"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxi-column
          dataField="sifra"
          caption="Šifra"
          [width]="100"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="naziv"
          caption="Naziv"
          [width]="400"
        ></dxi-column>
        <dxi-column
          dataField="narucenaKolicina"
          caption="Naručena količina"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="trenutnoStanje"
          caption="Trenutno stanje"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="prijedlogPlana"
          caption="Prijedlog plana"
          [width]="150"
          alignment="center"
          [hidingPriority]="2"
        ></dxi-column>
        <dxi-column
          dataField="uPlanu"
          caption="U planu"
          [width]="150"
          alignment="center"
          [hidingPriority]="1"
        ></dxi-column>
        <dxi-column
          dataField="narucenoUPaletama"
          caption="Naručeno u paletama"
          [width]="150"
          alignment="center"
          [hidingPriority]="0"
        ></dxi-column>
        <dxi-column
          caption="Naručitelji"
          [width]="150"
          alignment="center"
          cellTemplate="narucitelji"
        >
          <div *dxTemplate="let data of 'narucitelji'">
            <dx-button icon="video" [disabled]="pravaZaTrenutniPogled != 2">
            </dx-button>
          </div>
        </dxi-column>
        <dxi-column
          caption=""
          [width]="150"
          alignment="center"
          cellTemplate="planiraj"
        >
          <div *dxTemplate="let data of 'planiraj'">
            <div class="btn-dark">
              <dx-button
                [disabled]="pravaZaTrenutniPogled != 2"
                *ngIf="!planiraj"
                text="PLANIRAJ"
                (onClick)="planirajBtn()"
              >
              </dx-button>
              <dx-button
                [disabled]="pravaZaTrenutniPogled != 2"
                *ngIf="planiraj"
                text="ODUSTANI"
                (onClick)="odustaniBtn()"
              >
              </dx-button>
            </div>
          </div>
        </dxi-column>

        <div *dxTemplate="let employee of 'detail'">
          <dx-data-grid
            [dataSource]="nabavljaci"
            [showColumnLines]="true"
            [wordWrapEnabled]="true"
            keyExpr="sifra"
            noDataText="{{ porukaNabavljaci }}"
            [showBorders]="false"
          >
            <dxi-column
              dataField="narucitelj"
              caption="Naručitelj"
            ></dxi-column>
            <dxi-column
              dataField="narucenaKolicina"
              caption="Naručena količina"
              [width]="150"
              alignment="center"
            ></dxi-column>
            <dxi-column
              dataField="min"
              caption="Min"
              [width]="150"
              alignment="center"
            ></dxi-column>
            <dxi-column
              dataField="max"
              caption="Max"
              [width]="150"
              alignment="center"
            ></dxi-column>
            <dxi-column
              dataField="datumNarudzbe"
              caption="Datum narudžbe"
              [width]="150"
              alignment="center"
            ></dxi-column>
            <dxi-column
              dataField="datumUtovara"
              caption="Datum utovara"
              [width]="150"
              alignment="center"
            ></dxi-column>
            <dxi-column
              dataField="prijedlogPlana"
              caption="Prijedlog plana"
              [width]="150"
              alignment="center"
            ></dxi-column>
          </dx-data-grid>
        </div>
      </dx-data-grid>
    </div>
  </div>

  <div *ngIf="planiraj" class="content-block planiraj">
    <ul class="week-grid">
      <li>
        <div class="week-header">
          <span class="day-name">{{ odabranTjedan.day1ime }}</span>
          <span class="day-date">{{ odabranTjedan.day1datum }}</span>
        </div>
        <div class="smjene">
          <span (click)="odabirSmjene($event, odabranTjedan.day1datum, 1)"
            >SMJENA 1</span
          >
          <span (click)="odabirSmjene($event, odabranTjedan.day1datum, 2)"
            >SMJENA 2</span
          >
          <span (click)="odabirSmjene($event, odabranTjedan.day1datum, 3)"
            >SMJENA 3</span
          >
        </div>
      </li>
      <li>
        <div class="week-header">
          <span class="day-name">{{ odabranTjedan.day2ime }}</span>
          <span class="day-date">{{ odabranTjedan.day2datum }}</span>
        </div>
        <div class="smjene">
          <span (click)="odabirSmjene($event, odabranTjedan.day2datum, 1)"
            >SMJENA 1</span
          >
          <span (click)="odabirSmjene($event, odabranTjedan.day2datum, 2)"
            >SMJENA 2</span
          >
          <span (click)="odabirSmjene($event, odabranTjedan.day2datum, 3)"
            >SMJENA 3</span
          >
        </div>
      </li>
      <li>
        <div class="week-header">
          <span class="day-name">{{ odabranTjedan.day3ime }}</span>
          <span class="day-date">{{ odabranTjedan.day3datum }}</span>
        </div>
        <div class="smjene">
          <span (click)="odabirSmjene($event, odabranTjedan.day3datum, 1)"
            >SMJENA 1</span
          >
          <span (click)="odabirSmjene($event, odabranTjedan.day3datum, 2)"
            >SMJENA 2</span
          >
          <span (click)="odabirSmjene($event, odabranTjedan.day3datum, 3)"
            >SMJENA 3</span
          >
        </div>
      </li>
      <li>
        <div class="week-header">
          <span class="day-name">{{ odabranTjedan.day4ime }}</span>
          <span class="day-date">{{ odabranTjedan.day4datum }}</span>
        </div>
        <div class="smjene">
          <span (click)="odabirSmjene($event, odabranTjedan.day4datum, 1)"
            >SMJENA 1</span
          >
          <span (click)="odabirSmjene($event, odabranTjedan.day4datum, 2)"
            >SMJENA 2</span
          >
          <span (click)="odabirSmjene($event, odabranTjedan.day4datum, 3)"
            >SMJENA 3</span
          >
        </div>
      </li>
      <li>
        <div class="week-header">
          <span class="day-name">{{ odabranTjedan.day5ime }}</span>
          <span class="day-date">{{ odabranTjedan.day5datum }}</span>
        </div>
        <div class="smjene">
          <span (click)="odabirSmjene($event, odabranTjedan.day5datum, 1)"
            >SMJENA 1</span
          >
          <span (click)="odabirSmjene($event, odabranTjedan.day5datum, 2)"
            >SMJENA 2</span
          >
          <span (click)="odabirSmjene($event, odabranTjedan.day5datum, 3)"
            >SMJENA 3</span
          >
        </div>
      </li>
      <li>
        <div class="week-header">
          <span class="day-name">{{ odabranTjedan.day6ime }}</span>
          <span class="day-date">{{ odabranTjedan.day6datum }}</span>
        </div>
        <div class="smjene">
          <span (click)="odabirSmjene($event, odabranTjedan.day6datum, 1)"
            >SMJENA 1</span
          >
          <span (click)="odabirSmjene($event, odabranTjedan.day6datum, 2)"
            >SMJENA 2</span
          >
          <span (click)="odabirSmjene($event, odabranTjedan.day6datum, 3)"
            >SMJENA 3</span
          >
        </div>
      </li>
      <li>
        <div class="week-header">
          <span class="day-name">{{ odabranTjedan.day7ime }}</span>
          <span class="day-date">{{ odabranTjedan.day7datum }}</span>
        </div>
        <div class="smjene">
          <span (click)="odabirSmjene($event, odabranTjedan.day7datum, 1)"
            >SMJENA 1</span
          >
          <span (click)="odabirSmjene($event, odabranTjedan.day7datum, 2)"
            >SMJENA 2</span
          >
          <span (click)="odabirSmjene($event, odabranTjedan.day7datum, 3)"
            >SMJENA 3</span
          >
        </div>
      </li>
    </ul>
  </div>

  <div *ngIf="odabranaSmjena" class="m-40 p-relative">
    <div class="customTable tablicaLinije d-inline">
      <dx-data-grid
        #tablicaLinije
        [dataSource]="linije"
        noDataText="{{ porukaLinije }}"
        [wordWrapEnabled]="true"
        [showColumnLines]="true"
        keyExpr="linija"
        [showBorders]="false"
        (onCellPrepared)="getCell($event)"
        (onRowUpdated)="spremiPromjene($event)"
      >
        <dxo-editing
          mode="batch"
          [allowUpdating]="true"
          [allowDeleting]="false"
          [selectTextOnEditStart]="selectTextOnEditStart"
          [startEditAction]="startEditAction"
        >
        </dxo-editing>

        <dxi-column
          dataField="linija"
          caption="Naziv linije"
          [width]="250"
          [allowEditing]="false"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="maksimum"
          caption="Maksimum linije za odabrani proizvod"
          [allowEditing]="false"
          [width]="200"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="planirano"
          caption="Planirana količina"
          [width]="100"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="idKupac"
          caption="Kupac"
          alignment="center"
          [width]="300"
          [editorOptions]="{ showClearButton: true }"
          [hidingPriority]="2"
        >
          <dxo-lookup
            [dataSource]="nabavljaci"
            displayExpr="narucitelj"
            valueExpr="idNarucitelj"
            placeholder="Odaberi kupca"
          >
          </dxo-lookup>
        </dxi-column>
        <dxi-column
          dataField="napomena"
          caption="Napomena"
          [width]="250"
          [hidingPriority]="1"
        ></dxi-column>
        <dxi-column
          dataField="djelatnici"
          caption="Djelatnici"
          alignment="center"
          cellTemplate="djelatnici"
          [width]="300"
          [allowEditing]="false"
          [hidingPriority]="0"
        >
          <div *dxTemplate="let data of 'djelatnici'">
            <dx-tag-box
              #tagBox
              [value]="data.value"
              [dataSource]="djelatnici"
              placeholder="Dodaj djelatnika"
              valueExpr="name"
              displayExpr="name"
              [searchEnabled]="true"
              [searchExpr]="['name']"
              (onValueChanged)="onTagBoxValueChanged($event, data)"
            >
            </dx-tag-box>
          </div>
        </dxi-column>
        <dxi-column
          *ngIf="postojiPolovicnaPaleta"
          dataField="idPalete"
          caption="Nadopuna polovične palete?"
          [width]="300"
          [editorOptions]="{ showClearButton: true }"
        >
          <dxo-lookup
            [dataSource]="polovicnePalete"
            displayExpr="prikaz"
            valueExpr="idPlan"
            placeholder="Nadopuna polovične palete?"
          >
          </dxo-lookup>
        </dxi-column>

        <dxo-summary [recalculateWhileEditing]="true">
          <dxi-total-item column="planirano" summaryType="sum">
          </dxi-total-item>
        </dxo-summary>
      </dx-data-grid>
    </div>

    <div class="d-inline tablicaLinije-right p-absolute">
      <span class="d-block plan-label">Prijedlog plana</span>
      <span class="d-block plan-number">{{ potrebnoProizvesti }}</span>
      <span class="d-block plan-label">Stavljeno u plan</span>
      <span
        *ngIf="uPlanu == uPlanuTmp"
        id="brojUplanu"
        class="d-block plan-number"
        >{{ uPlanu }}</span
      >
      <span
        *ngIf="uPlanu != uPlanuTmp"
        id="brojUplanu"
        class="d-block plan-number color-green"
        >{{ uPlanuTmp }}</span
      >
      <span class="d-block plan-label">Još potrebno proizvesti</span>
      <span
        *ngIf="uPlanu == uPlanuTmp"
        id="brojPotrebnoJos"
        class="d-block plan-number"
        >{{ potrebnoJos }}</span
      >
      <span
        *ngIf="uPlanu != uPlanuTmp"
        id="brojPotrebnoJos"
        class="d-block plan-number color-green"
        >{{ potrebnoJos }}</span
      >
      <button class="plan-save" (click)="spremiPlan()">Spremi plan</button>
    </div>
  </div>
</div>
